import type { ReactNode } from 'react';
import type { FieldSpan } from './FormField';

// Mockup .field wrapper for controlled / react-hook-form controls: label above (12px muted), required asterisk (.req), spans w2..w4,
// optional validation message under the control. Use FormField for simple value/onChange fields; this for RHF `register` / `Controller`.
export function FieldWrap({ label, htmlFor, required, span, error, hint, className, children }: { label: string; htmlFor?: string; required?: boolean; span?: FieldSpan; error?: string; hint?: string; className?: string; children: ReactNode }) {
  const cls = ['field', required ? 'req' : '', span && span > 1 ? `w${String(span)}` : '', className ?? ''].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      <label htmlFor={htmlFor}>{label}</label>
      {children}
      {error && (
        <small className="err" role="alert">
          {error}
        </small>
      )}
      {hint && !error && <small className="muted">{hint}</small>}
    </div>
  );
}
